import { Progress } from "~/atoms/progress";

interface WorkflowProgressProps {
  workflow: {
    completedSteps: number;
    totalSteps: number;
  };
}

export const WorkflowProgress = ({ workflow }: WorkflowProgressProps) => {
  const { completedSteps, totalSteps } = workflow;

  if (totalSteps <= 0) {
    return null;
  }

  const percentage = (completedSteps / totalSteps) * 100;

  return (
    <div className="flex items-center gap-2">
      <Progress value={percentage} />
      <span className="text-muted-foreground text-sm">
        {completedSteps}/{totalSteps}
      </span>
    </div>
  );
};
